import { render, staticRenderFns } from "./paper.vue?vue&type=template&id=46bd8e70&scoped=true&"
import script from "./paper.vue?vue&type=script&lang=js&"
export * from "./paper.vue?vue&type=script&lang=js&"
import style0 from "./paper.vue?vue&type=style&index=0&id=46bd8e70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bd8e70",
  null
  
)

export default component.exports